export const roomSheetSlug = (value) => String(value || "sin-nombre")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "-")
  .replace(/^-|-$/g, "");

export const waitForSheetAssets = async (element) => {
  if (document.fonts?.ready) await document.fonts.ready;
  const images = Array.from(element?.querySelectorAll("img") || []);
  await Promise.all(images.map(async (image) => {
    if (image.complete) return;
    try { await image.decode(); } catch { /* browser fallback */ }
  }));
};

export const downloadRoomSheetPdf = async (element, room) => {
  if (!element) throw new Error("No se encontró la hoja para descargar");
  await waitForSheetAssets(element);
  const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
    import("html2canvas"),
    import("jspdf"),
  ]);
  const prefix = room.kind === "cabin" ? "cabana" : "habitacion";
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: false,
    backgroundColor: "#fdfbf7",
    width: 816,
    height: 1056,
    windowWidth: 816,
    windowHeight: 1056,
    scrollX: 0,
    scrollY: 0,
    logging: false,
    onclone: (_document, clone) => {
      clone.style.transform = "none";
      clone.style.margin = "0";
    },
  });

  const pixels = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height).data;
  let hasVisibleInk = false;
  for (let y = 0; y < canvas.height && !hasVisibleInk; y += 64) {
    for (let x = 0; x < canvas.width; x += 64) {
      const index = (y * canvas.width + x) * 4;
      if (pixels[index] < 240 || pixels[index + 1] < 240 || pixels[index + 2] < 240) {
        hasVisibleInk = true;
        break;
      }
    }
  }
  if (!hasVisibleInk) throw new Error("El PDF quedó vacío; intenta nuevamente");

  const pdf = new jsPDF({ orientation: "portrait", unit: "in", format: "letter", compress: true });
  pdf.addImage(canvas.toDataURL("image/jpeg", 0.96), "JPEG", 0, 0, 8.5, 11, undefined, "FAST");
  return pdf.save(`operacion-rescate-${prefix}-${roomSheetSlug(room.name)}.pdf`);
};